var module = angular.module('octopusApp.projects');

module.service('actionExecutionLocations', function () {

    this.alwaysOnTarget = 'AlwaysOnTarget';
    this.alwaysOnServer = 'AlwaysOnServer';
    this.targetOrServer = 'TargetOrServer';
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/services/action_execution_locations_service.js
// module id = 5296566886475320
// module chunks = 1